import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  checkFeatureFlag,
  setCurrentPageName
} from 'actions'
import {
  getWorkspace,
  shouldShowFeature
} from 'selectors'
import CustomersHome from '../components/Customers/CustomersHome'

class CustomersApp extends Component {
  render () {
    return React.createElement(CustomersHome, this.props)
  }

  componentDidMount () {
    this.props.checkFeatures()
    this.props.setCurrentPageName('customers')

    window.analytics.page('Customers', {
      workspace_id: this.props.workspace.id,
      user_id: this.props.currentUser.id
    })
  }
}

function mapStateToProps (state, ownProps) {
  const { workspaceSlug } = ownProps.params
  const workspace = getWorkspace(state, workspaceSlug)
  const { currentUser } = state

  return {
    workspace,
    currentUser,
    shouldShowCustomers: shouldShowFeature(state, 'app_customers')
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    checkFeatures: () => dispatch(checkFeatureFlag('app_customers')),
    setCurrentPageName: name => dispatch(setCurrentPageName(name))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomersApp)



// WEBPACK FOOTER //
// ./containers/CustomersApp.js